/**
 * Values that shaped Anderson's engineering philosophy.
 * Automattic Creed and TaxJar Way, both kept on the office board.
 */

export const automatticCreed = [
  'I will never stop learning.',
  "I won't just work on things that are assigned to me.",
  "There's no such thing as a status quo.",
  'Never pass up an opportunity to help a colleague.',
  'More motivated by impact than money.',
  'Communicate as much as possible.',
  "Marathon, not a sprint.",
  'Given time, no problem is insurmountable.',
]

export const taxjarWay = [
  'We are always learning & growing',
  'We know that we are better together',
  'We build relationships that matter',
  'We shape our own destiny',
  'In pursuit of better',
]
